module.exports = "<ul class=\"list-rubriques\">\n  <li *ngFor=\"let rubrique of getRubriques()\" (click)=\"onClickRubrique(rubrique)\" >\n    <img src=\"{{ rubrique.img }}\" [alt]=\"rubrique.name | toReverseHtml\" [title]=\"rubrique.name | toReverseHtml\" class=\"{{ getRubriqueCssClass(rubrique) }}\" />\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/creator/rubriques/rubriques.component.html
// module id = 307
// module chunks = 1